import { Divider, MenuItem, mergeClasses } from '@fluentui/react-components';
import { ChevronDownRegular, ChevronUpRegular, EyeOffRegular } from '@fluentui/react-icons';
import type { Column } from '@tanstack/react-table';
import { type ReactNode, useCallback } from 'react';
import { useStyles } from './styles.js';

type DataTableHeaderCellSurfaceProps<TData, TValue> = {
    column: Column<TData, TValue>;
    closePopover: () => void;
    filterNode: ReactNode;
};

export function DataTableHeaderCellSurface<TData, TValue>({
    column,
    closePopover,
    filterNode,
}: DataTableHeaderCellSurfaceProps<TData, TValue>) {
    const styles = useStyles();

    const sortingAsc = useCallback(() => {
        closePopover();
        column.toggleSorting(false);
    }, [closePopover, column.toggleSorting]);

    const sortingDesc = useCallback(() => {
        closePopover();
        column.toggleSorting(true);
    }, [closePopover, column.toggleSorting]);

    const disableVisibility = useCallback(() => {
        closePopover();
        column.toggleVisibility(false);
    }, [closePopover, column.toggleVisibility]);

    return (
        <div>
            <div className={styles.menuItem}>
                <MenuItem icon={<ChevronUpRegular />} onClick={sortingAsc}>
                    Aufsteigend
                </MenuItem>
                <MenuItem icon={<ChevronDownRegular />} onClick={sortingDesc}>
                    Absteigend
                </MenuItem>
            </div>

            <Divider />

            <div className={styles.menuItem}>
                <MenuItem icon={<EyeOffRegular />} onClick={disableVisibility}>
                    Ausblenden
                </MenuItem>
            </div>

            <Divider />

            <div className={mergeClasses(styles.menuItem, styles.filterContainer)}>
                {column.getCanFilter() && filterNode}
            </div>
        </div>
    );
}
